import BigNumber from "bignumber.js"
import { TransactionType } from "state/info/types"
import { BurnResponse, MintResponse } from "./types"

export const mapMints = (mint: MintResponse) => {
  return {
    type: TransactionType.MINT,
    id: mint.pair.id,
    name: mint.pair.name,
    sender: mint.to,
    liquidity: new BigNumber(mint.liquidity),
    amountUSD: new BigNumber(mint.amountUSD),
    amountToken0: new BigNumber(mint.amount0),
    amountToken1: new BigNumber(mint.amount1),
  }
}

export const mapBurns = (burn: BurnResponse) => {
  return {
    type: TransactionType.BURN,
    id: burn.pair.id,
    name: burn.pair.name,
    sender: burn.sender,
    liquidity: new BigNumber(burn.liquidity),
    amountUSD: new BigNumber(burn.amountUSD),
    amountToken0: new BigNumber(burn.amount0),
    amountToken1: new BigNumber(burn.amount1),
  }
}